import {
  Dialog,
  DialogContent,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextLines from '../../../text/TextLines';
import './InstructionDialog.scss';

export default function InstructionDialog({
  instructions,
  open,
  onClose,
  className,
} = {
  instructions: {},
  open: false,
  onClose: () => {},
  className: '',
}) {
  return open ? (
    <Dialog open={open} className={`instruction-dialog ${instructions.audio ? 'instruction-dialog-with-audio' : ''} ${className}`}>
      <IconButton
        aria-label='close instructions'
        className='close-button'
        onClick={onClose}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
            onClose();
          }
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className='content'>
        {
          instructions.text ? <TextLines textLines={instructions.text} /> : ''
        }
      </DialogContent>
    </Dialog>
  ) : null;
}
